var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'notify',
    'notify--' + _vm.type ]},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"notify__icon",attrs:{"icon":_vm.icon}}):_vm._e(),(_vm.title)?_c('h3',{staticClass:"notify__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.text)?_c('h3',{staticClass:"notify__text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }